// extracted by mini-css-extract-plugin
export var isWhite = "styles-module--isWhite--9Nqpw";
export var mainMenuArea = "styles-module--mainMenuArea--E7XQy";
export var menuPrinicipal = "styles-module--menuPrinicipal--0JjAf";
export var separacion = "styles-module--separacion--8KG2M";
export var separacionArea = "styles-module--separacionArea--pno3o";